import { Endpoints } from "../../endpoints";
import { transformData } from "../utils/data.utils";
import { errorHandler } from "../utils/error-handler.utils";

AFRAME.registerSystem("data", {
  cache: {},
  promises: {},

  fetch: function (url) {
    if (this.cache[url]) {
      return Promise.resolve(this.cache[url]);
    }

    if (this.promises[url]) {
      return this.promises[url];
    }

    return (this.promises[url] = fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Data request failed (${response.status}): ${url}`);
        }
        return response.json();
      })
      .then((data) => {
        const dataLocalised = transformData(data);
        // Keep monthly rotations server-authoritative, independent of the client clock.
        if (url !== Endpoints.newArrivals()) {
          // TODO: Account for lang when caching
          this.cache[url] = dataLocalised;
        }
        delete this.promises[url];
        return dataLocalised;
      })
      .catch((e) => {
        delete this.promises[url];
        errorHandler(e, "data-system-error", "data-system");
      }));
  },
});
